import axios from 'axios'
import history from '../history'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})
const HEADERS = {
    'Content-Type': 'application/json'
};

export async function postAtivarUsuario(id, code, dispatch) {
    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/account/activateperson',
        {
            "person_id": id,
            "activation_code": code
        },
        {
            headers: HEADERS
        }).then(response => {
            successPostAtivarUsuario(response, dispatch);
        }).catch(erro => {
            erroPostAtivarUsuario(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successPostAtivarUsuario(response, dispatch) {
    if (response.status === 200) {
        dispatch({
            type: 'CLOSE_ATIVAR_CONTA'
        })
        history.push('/login')
    }
}

function erroPostAtivarUsuario(erro, dispatch) {
    if (erro !== undefined && erro.status === 400) {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Ativar conta',
            description: 'Codigo invalido'
        })
    }
}

export async function postReenviarCodigo(email, dispatch) {

    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/account/resend',
        {
            "email": email,
            "type": "code"
        },
        {
            headers: HEADERS
        }).then(response => {
            successPostReenviarCodigo(response, dispatch);
        }).catch(erro => {
            erroPostReenviarCodigo(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successPostReenviarCodigo(response, dispatch) {
    if (response.status === 200) {
        dispatch({
            type: 'OPEN_ALERT_DIALOG',
            title: 'Ativar conta',
            description: 'Codigo reenviado, verifique seu e-mail'
        })
    }
}

function erroPostReenviarCodigo(erro, dispatch) {
    console.log(erro)
}